import { Product, Brand } from '../types';
import { mockProducts, mockBrands } from '../data/mockData';
import api from './api';

const USE_MOCK = process.env.REACT_APP_USE_MOCK !== 'false';

export async function fetchProducts(category?: string): Promise<Product[]> {
  if (USE_MOCK) {
    await new Promise((r) => setTimeout(r, 400));
    if (category) return mockProducts.filter((p) => p.category === category);
    return mockProducts;
  }
  try {
    const params = category ? { category } : {};
    const { data } = await api.get<Product[]>('/products', { params });
    return data;
  } catch {
    // Fall back to mock data so products always display even if API is down
    console.warn('Products API unavailable – showing sample products');
    if (category) return mockProducts.filter((p) => p.category === category);
    return mockProducts;
  }
}

export async function fetchProduct(productId: string): Promise<Product> {
  if (USE_MOCK) {
    const p = mockProducts.find((p) => p.productId === productId);
    if (!p) throw new Error('Product not found');
    return p;
  }
  const { data } = await api.get<Product>(`/products/${productId}`);
  return data;
}

export async function fetchBrands(): Promise<Brand[]> {
  if (USE_MOCK) {
    return mockBrands;
  }
  const { data } = await api.get<Brand[]>('/products/brands');
  return data;
}

/**
 * Loads all Sigvaris/Relaxsan catalogue products from /catalogue/products.
 * Always fetches from the API (products are served from S3 catalogues).
 */
export async function fetchCatalogueProducts(): Promise<Product[]> {
  try {
    const { data } = await api.get<Product[]>('/catalogue/products');
    return data;
  } catch (err) {
    console.warn('Catalogue API unavailable – compression catalogue not loaded', err);
    return [];
  }
}

/**
 * Loads brace catalogue products from /catalogue/braces/products.
 * Always fetches from the API (products are served from S3 catalogues).
 */
export async function fetchBraceCatalogueProducts(): Promise<Product[]> {
  try {
    const { data } = await api.get<Product[]>('/catalogue/braces/products');
    return data;
  } catch (err) {
    console.warn('Brace catalogue API unavailable', err);
    return [];
  }
}
